import React from "react"
import { useEffect, useState } from "react"
// MUI components
import Box from "@mui/material/Box"
import Paper from "@mui/material/Paper"
import Typography from "@mui/material/Typography"
import CircularProgress from "@mui/material/CircularProgress"
import WarningAmberIcon from "@mui/icons-material/WarningAmber"
import { useTranslation } from "react-i18next"


export default function Unavailable() {
    const { t } = useTranslation();

    return (
        <Box className="container-unavailable">
            <Paper
                elevation={3}
                className="container-unavailable-paper"
            >


                <Box className="container-unavailable-content">
                    {/* Icon container */}
                    <Box className="container-unavailable-icon">
                        <WarningAmberIcon color="primary" className="icon-unavailable-warning" />
                    </Box>

                    <Typography variant="h5" component="h1" fontWeight="bold" gutterBottom>
                        {t('error.unavailable_organization')}
                    </Typography>

                    <Typography variant="body1" color="text.secondary" className="text-unavailable-description">
                        {t('error.please_use_correct_organization_code')}
                    </Typography>

                </Box>
            </Paper>
        </Box>
    )
}
